(function () {
  if (customElements.get('et-home-categories-slider')) return;

  const SLIDER_QUERY = '(max-width: 989px)';
  const TABLET_MIN_WIDTH = 750;

  class EtHomeCategoriesSlider extends HTMLElement {
    constructor() {
      super();
      this.onBreakpointChange = () => this.toggle();
      this.addEventListener('shopify:block:select', event => this.showBlock(event.target));
    }

    connectedCallback() {
      if (this.mediaQuery) return;

      this.container = this.querySelector('.swiper');
      if (!this.container) return;

      this.mediaQuery = window.matchMedia(SLIDER_QUERY);
      this.mediaQuery.addEventListener('change', this.onBreakpointChange);

      if (typeof window.Swiper === 'undefined') {
        window.addEventListener('load', this.onBreakpointChange, { once: true });
        return;
      }

      this.toggle();
    }

    disconnectedCallback() {
      if (this.mediaQuery) {
        this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
        this.mediaQuery = null;
      }

      this.destroy();
    }

    toggle() {
      if (this.mediaQuery && this.mediaQuery.matches) {
        this.init();
      } else {
        this.destroy();
      }
    }

    init() {
      if (this.swiper || !this.isConnected || typeof window.Swiper === 'undefined') return;

      const styles = getComputedStyle(this);
      const readNumber = (name, fallback) => parseFloat(styles.getPropertyValue(name)) || fallback;

      this.swiper = new window.Swiper(this.container, {
        slidesPerView: readNumber('--et-slides-mobile', 1),
        spaceBetween: readNumber('--et-slider-gap', 0),
        breakpoints: {
          [TABLET_MIN_WIDTH]: { slidesPerView: readNumber('--et-slides-tablet', 1) }
        },
        watchOverflow: true,
        grabCursor: true,
        threshold: 5
      });
    }

    destroy() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    showBlock(block) {
      if (!this.swiper) return;

      const index = Array.from(this.swiper.slides).indexOf(block.closest('.swiper-slide'));
      if (index > -1) this.swiper.slideTo(index);
    }
  }

  customElements.define('et-home-categories-slider', EtHomeCategoriesSlider);
})();
